// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r1-2";
export var chatLink = "_r1-0";
export var chatText = "_r1-1";